module.exports = __webpack_public_path__ + "img/3-r.3b0f4808.png";